import React from "react";
import logo from "../../assets/images/image/solar-logo.png";
import { Link, NavLink } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import moment from "moment";

const Footer = () => {
  return (
    <>
      <footer className="text-center text-dark text-lg-start text-muted">
        <section className="text-white">
          <div className="container text-center text-md-start pt-5">
            <div className="row w-100">
              <div className="col-md-6 col-lg-3 mx-auto mb-4">
                <h6 className=" mb-4">
                  <img src={logo} alt="logo" />
                </h6>
                <p className="text-dark">
                  We are committed to harnessing the power of the sun to provide sustainable, clean, and cost-effective energy solutions.
                </p>

                <div className="wrapper-social-icons">
              
                  {/* <a href="#" className="icon twitter">
                    <div className="tooltip">Twitter</div>
                    <span>
                      <FaTwitter />
                    </span>
                  </a> */}
                  <a href="https://www.facebook.com/share/16zrYVth6P/?mibextid=wwXIfr" target="_blank" className="icon twitter"><i className="bi bi-facebook"></i></a>
            <a href="https://youtube.com/@energybazzar?si=52HeyIF87lkgEA1E" target="_blank" className="icon twitter"><i className="bi bi-youtube "></i></a>
            <a href="https://www.instagram.com/energy_bazzar/profilecard/?igsh=MWdpNWFsaHkyOGhiNg==" target="_blank" className="icon twitter"><i className="bi bi-instagram "></i></a>
             <a href="https://x.com/energybazzar?s=21" target="_blank" className="icon twitter"><i className="bi bi-twitter-x "></i></a>
             <a href="https://wa.me/message/ZS2DVQ6CORCXO1" target="_blank" className="icon twitter"><i className="bi bi-whatsapp "></i></a>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">How to Sell Fast</h6>
                <p>
                  <a
                    href="./pages/videos/Sell product.html"
                    className="text-decoration-none text-secondary"
                  >
                    Selling Tips
                  </a>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Buy and Sell Quickly
                  </a>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Membership
                  </a>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Banner Advertising
                  </a>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Promote Your Ad
                  </a>
                </p>
              </div>

              <div className="col-md-6 col-lg-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Information</h6>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Company & Contact Info
                  </a>
                </p>
                <p>
                  <NavLink
                    to="/Blogs"
                    className="text-decoration-none text-secondary"
                  >
                    Blog & Articles
                  </NavLink>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Sitemap
                  </a>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Terms of Service
                  </a>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Privacy Policy
                  </a>
                </p>
              </div>

              <div className="col-md-6 col-lg-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Help & Support</h6>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Live Chat
                  </a>
                </p>
                <p>
                  <NavLink to="/faqs" className="text-decoration-none text-secondary">
                    FAQ
                  </NavLink>
                </p>
                <p>
                  <NavLink to="/about-us" className="text-decoration-none text-secondary">
                    About Us
                  </NavLink>
                </p>
                <p>
                  <a className="text-decoration-none text-secondary">
                    Terms & Conditions
                  </a>
                </p>
                <p>
                  <NavLink to="/contact-us" className="text-decoration-none text-secondary">
                    Contact Us
                  </NavLink>
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="radial text-secondary">
          <div className="container">
            <div className="text-center p-4">
              © Copyright EnergyBazzar {moment().format('YYYY')}.
              {/* Designed and Developed by{' '}  */}
              {/* <a className="text-decoration-none text-orange fw-bold" href="#">
                EnergyBazzar.com
              </a> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
